module.exports = __webpack_public_path__ + "img/down.6974bfc9.svg";